import styled from "styled-components";

import "./modal.css";
import React, { useEffect, useState } from "react";
import buildClassName from "../../../utils/buildClassName";
interface ModalProps {
  width?: string;
  height?: string;
  minHeight?: string;
  color?: string;
  isAbsolute?: boolean;
}
interface Props extends ModalProps {
  show: boolean;
  type?: string;
  handleClose: () => void;
  children: React.ReactNode;
}

const ModalContainer = styled.div<ModalProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  position: ${(p) => p.isAbsolute ? 'absolute' : 'fixed'};
  width: 311px;
  //min-height: 148px;
  width: ${(p) => p.width};
  min-height: ${(p) => p.minHeight};
  height: ${(p) => p.height};
  background: ${(p) => (theme: any) =>
  p.color ? theme.theme[p.color] : theme.theme["Light5"]};
  border-radius: 16px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const ModalView = (props: Props) => {
  const [showModal, setShowModal] = useState(props.show);
  useEffect(() => {
    setShowModal(props.show);
  }, [props.show]);
  /**
   * Close Menu when clicked outside
   */

  return (
    <div className={buildClassName("modal", showModal && "display-block", props.isAbsolute && 'absolute')}>
      <ModalContainer
        isAbsolute={props.isAbsolute}
        width={props.width}
        height={props.height}
        color={props.color}
      >
        {props.children}
      </ModalContainer>
    </div>
  );
};
